import React, { Component } from "react";
import FlipbookMainContent from "../FunctionalComp/FlipbookContent/FlipbookMainContent";

class FlipbookMain extends Component {
  render() {
    return (
      <div>
        <FlipbookMainContent />
      </div>
    );
  }
}

export default FlipbookMain;
